export const ITEM_TYPE_CSV = 'CSV'
export const ITEM_TYPE_DEFAULT = 'Default'